module.exports = __webpack_public_path__ + "static/media/jan-sendereks.c5a61800.jpg";